




























































































































import { Vue, Component, Prop, Watch, Mixins } from "vue-property-decorator";
import { namespace, Getter } from "vuex-class";
import { debounce } from "lodash";

import VuePerfectScrollbar from "vue-perfect-scrollbar";
import MatrixContent from "@/components/media/sidebar/MatrixContent.vue";
import AreaCameras from "@/components/media/sidebar/AreaCameras.vue";

import { stringMixin } from "@/mixins";
import { renderDistance } from "@/filters";
import { CameraSearch, CameraType } from "@/store/site-monitor-cameras/types";
import { EventDetails } from "@/store/site-monitor/types";
import MatrixCameraMixin from "./MatrixCameraMixin";

const { isNullOrWhitespace } = stringMixin.methods;

const SiteMonitorCameras = namespace("siteMonitorCameras");

@Component({
	components: {
		"area-cameras": AreaCameras,
		"matrix-content": MatrixContent,
		"vue-perfect-scrollbar": VuePerfectScrollbar,
	},
	filters: {
		renderDistance,
	},
})
export default class CameraList extends Mixins(MatrixCameraMixin) {
	@Getter private getFeature: (featureName: string[]) => boolean;

	@SiteMonitorCameras.Action private searchForCameras: ({ query, groupID }) => Promise<void>;
	@SiteMonitorCameras.Mutation private setSearchedCameraIndex: ({ cameraId, index }) => void;

	private cameraSearchQuery: string = "";
	private cameraSearchExpanded: boolean = true;
	private nearbyCamerasExpanded: boolean = true;
	private matrixCamerasExpanded: boolean = true;

	/**
	 * Returns true if the Open Camera List feature is enabled.
	 */
	private get showMatrixCameras() {
		return this.getFeature(["Alarms", "MediaMatrix", "OpenCameraList"]);
	}

	/**
	 * Returns cameras filtered by our search query from the nearby area.
	 */
	private get filteredNearbyCameras() {
		let camerasToFilter = this.cameras;

		if (isNullOrWhitespace(this.cameraSearchQuery)) {
			return camerasToFilter;
		}

		const filter = this.cameraSearchQuery.toLocaleLowerCase();
		return camerasToFilter.filter((camera) => camera.title.toLocaleLowerCase().indexOf(filter) > -1);
	}

	/**
	 * When the event ID is changed, we reset the camera search query.
	 */
	@Watch("eventId")
	private onEventIdChanged() {
		this.cameraSearchQuery = "";
		this.setAwaitingCamera(null);
	}

	/**
	 * When the camera query is changed, performs a server-side search.
	 */
	@Watch("cameraSearchQuery")
	private async onCameraSearchQueryChanged(query: string) {
		await this.findCameras(query);
	}

	/**
	 * When the matrix is updated, updates searched camera indices.
	 */
	@Watch("mediaMatrixLastChanged")
	private onMatrixChanged() {
		if (this.searchedCameras != null && this.searchedCameras.length > 0) {
			this.setSearchCameraIndexes();
		}
	}

	/**
	 * Performs a search on the server side when our camera query changes.
	 */
	private findCameras = debounce(async function (query: string) {
		let { groupID } = this.eventDetails;
		await this.searchForCameras({ query, groupID });
		this.setSearchCameraIndexes();
	}, 300);

	/**
	 * Updates the searched cameras to ensure their index matches the location of the camera in the matrix.
	 */
	private setSearchCameraIndexes() {
		let deviceIndexes = {};
		let maxtrixContents = this.allMatrixContents;

		for (var matrixIndex in maxtrixContents) {
			if (maxtrixContents[matrixIndex] != null && maxtrixContents[matrixIndex].camera != null) {
				deviceIndexes[maxtrixContents[matrixIndex].camera.objectID] = parseInt(matrixIndex);
			}
		}

		this.searchedCameras.forEach((camera) => {
			this.setSearchedCameraIndex({
				cameraId: camera.objectID,
				index: deviceIndexes[camera.objectID] != null ? deviceIndexes[camera.objectID] : null,
			});
		});
	}
}
